import PageApp from '../views/PageApp.vue'

export default [
  {
    path: '/app/interactions/geniebot/:contactId/:type',
    name: 'app-interactions-geniebot',
    component: PageApp,
    meta: {
      pub: true,
      isIFramePage: true
    }
  },
]